import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_get_materials_basepackaging_by_materialIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { materialId: number }): 
  Promise<{ result: { MaterialId?: number, PackagingId?: number, IsBasePackaging?: boolean, WeightUomId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.materialId)) {
      $missingRequiredInParams.push('\'materialId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      materialId: number    }) {
        if(isNil($inParams.materialId)) {
          return true; 
        }
      return false;
    }
}
